<template>
    <div class="layout">
        <header-custom></header-custom>
        <div ref="layoutContent" class="layout__content overflow-hidden">
            <transition @enter="enterAnim" @leave="leaveAnim" mode="out-in">
                <router-view/>
            </transition>
        </div>
        <div ref="transition" class="transition w-screen h-0 bg-white fixed"></div>
    </div>
</template>

<script>
    import HeaderCustom from './components/HeaderCustom.vue';
    import { TweenMax } from 'gsap';

    export default {
        components: { HeaderCustom },

        data(){
            return {
                currentPage : this.$route.name
            }
        },

        methods : {
            enterAnim(pEl, pDone){
                TweenMax.fromTo(this.$refs.transition, 0.5, {
                    top : 'auto',
                    bottom : 0
                },{
                    height : 0,
                    ease : Expo.easeOut,
                    onComplete : pDone
                });
            },

            leaveAnim(pEl, pDone){
                TweenMax.fromTo(this.$refs.transition, 0.5, {
                    top : 0,
                    bottom : 'auto'
                },{
                    height : window.innerHeight,
                    ease : Expo.easeOut,
                    onComplete : pDone
                });
            }
        }
    }
</script>

<style>
    h1, h2, h3, h4, p {
        font-smooth: always;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        font-weight : normal;
    }

    @font-face {
        font-family: 'coign-bold';
        src: url('./assets/fonts/coign/coign-37-bold-pro.woff2') format('woff2'), url('./assets/fonts/coign/coign-37-bold-pro.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'signal-regular';
        src: url('./assets/fonts/signal/signal-regular.woff2') format('woff2'), url('./assets/fonts/signal/signal-regular.woff') format('woff');
        font-weight: 400;
        font-style: normal;
    }

    @font-face {
        font-family: 'codesaver-regular';
        src: url('./assets/fonts/code-saver/code-saver-regular.woff2') format('woff2'), url('./assets/fonts/code-saver/code-saver-regular.woff') format('woff');
        font-weight: 400;
        font-style: normal;
    }

    @font-face {
        font-family: 'codesaver-italic';
        src: url('./assets/fonts/code-saver/code-saver-italic.woff2') format('woff2'), url('./assets/fonts/code-saver/code-saver-italic.woff') format('woff');
        font-weight: 400;
        font-style: normal;
    }

    .layout {
        height : calc(100vh + 1px);
    }

    .transition {
        top : 0;
        left : 50%;
        transform : translate(-50%,0);
    }
</style>


